"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f112 = void 0;
exports.f112 = {
    "pa": [
        "Guru",
        "Khoj",
        "Mahj",
        "Arab"
    ],
    "pab": [
        "Latn"
    ],
    "pac": [
        "Latn",
        "Laoo"
    ],
    "pad": [
        "Latn"
    ],
    "pae": [
        "Latn"
    ],
    "paf": [
        "Latn"
    ],
    "pag": [
        "Latn",
        "Brai"
    ],
    "pah": [
        "Latn"
    ],
    "pai": [
        "Latn"
    ],
    "pak": [
        "Latn"
    ],
    "pal": [
        "Phli",
        "Phlp"
    ],
    "pam": [
        "Latn",
        "Brai"
    ],
    "pao": [
        "Latn"
    ],
    "pap": [
        "Latn"
    ],
    "paq": [
        "Zyyy"
    ],
    "par": [
        "Latn"
    ],
    "pas": [
        "Latn"
    ],
    "pau": [
        "Latn"
    ],
    "pav": [
        "Latn"
    ],
    "paw": [
        "Latn"
    ],
    "pax": [
        "Latn"
    ],
    "pay": [
        "Latn"
    ],
    "paz": [
        "Latn"
    ],
    "pbb": [
        "Latn"
    ],
    "pbc": [
        "Latn"
    ],
    "pbe": [
        "Latn"
    ],
    "pbf": [
        "Latn"
    ],
    "pbg": [
        "Latn"
    ],
    "pbh": [
        "Latn"
    ],
    "pbi": [
        "Latn"
    ],
    "pbl": [
        "Latn"
    ],
    "pbm": [
        "Latn"
    ],
    "pbn": [
        "Latn"
    ],
    "pbo": [
        "Latn"
    ],
    "pbp": [
        "Latn"
    ],
    "pbr": [
        "Latn"
    ],
    "pbs": [
        "Latn"
    ],
    "pbt": [
        "Arab"
    ],
    "pbv": [
        "Latn"
    ],
    "pby": [
        "Latn"
    ],
    "pca": [
        "Latn"
    ],
    "pcb": [
        "Khmr"
    ],
    "pcc": [
        "Hani",
        "Latn"
    ],
    "pcd": [
        "Latn"
    ],
    "pce": [
        "Mymr",
        "Thai"
    ],
    "pcf": [
        "Zyyy"
    ],
    "pcg": [
        "Knda",
        "Mlym",
        "Taml"
    ],
    "pch": [
        "Deva"
    ],
    "pci": [
        "Deva",
        "Orya"
    ],
    "pcj": [
        "Telu"
    ],
    "pck": [
        "Latn"
    ],
    "pcl": [
        "Zyyy"
    ],
    "pcm": [
        "Latn"
    ],
    "pcn": [
        "Latn"
    ],
    "pcp": [
        "Latn"
    ],
    "pcw": [
        "Latn"
    ],
    "pda": [
        "Latn"
    ],
    "pdc": [
        "Latn"
    ],
    "pdi": [
        "Zyyy"
    ],
    "pdn": [
        "Latn"
    ],
    "pdo": [
        "Latn"
    ],
    "pdt": [
        "Latn"
    ],
    "pdu": [
        "Latn",
        "Mymr"
    ],
    "pea": [
        "Latn"
    ],
    "peb": [
        "Zyyy"
    ],
    "ped": [
        "Latn"
    ],
    "pee": [
        "Latn"
    ],
    "pef": [
        "Zyyy"
    ],
    "peg": [
        "Orya"
    ],
    "peh": [
        "Zyyy"
    ],
    "pei": [
        "Latn"
    ],
    "pej": [
        "Zyyy"
    ],
    "pek": [
        "Latn"
    ],
    "pel": [
        "Latn"
    ],
    "pem": [
        "Latn"
    ],
    "peo": [
        "Xpeo"
    ],
    "pep": [
        "Latn"
    ],
    "peq": [
        "Latn"
    ],
    "pev": [
        "Latn"
    ],
    "pex": [
        "Latn"
    ],
    "pey": [
        "Latn"
    ],
    "pez": [
        "Latn"
    ],
    "pfa": [
        "Latn"
    ],
    "pfe": [
        "Latn"
    ],
    "pfl": [
        "Latn"
    ],
    "pga": [
        "Latn"
    ],
    "pgd": [
        "Khar"
    ],
    "pgg": [
        "Deva"
    ],
    "pgi": [
        "Latn"
    ],
    "pgk": [
        "Latn"
    ],
    "pgl": [
        "Ogam"
    ],
    "pgn": [
        "Ital"
    ],
    "pgs": [
        "Latn"
    ],
    "pgu": [
        "Latn"
    ],
    "pgz": [
        "Zxxx"
    ],
    "pha": [
        "Zyyy"
    ],
    "phd": [
        "Zyyy"
    ],
    "phg": [
        "Latn"
    ],
    "phh": [
        "Latn"
    ],
    "phk": [
        "Mymr"
    ],
    "phl": [
        "Arab"
    ],
    "phm": [
        "Latn"
    ],
    "phn": [
        "Phnx"
    ],
    "pho": [
        "Laoo"
    ],
    "phq": [
        "Zyyy"
    ],
    "phr": [
        "Arab"
    ],
    "pht": [
        "Thai"
    ],
    "phu": [
        "Lana",
        "Laoo",
        "Thai"
    ],
    "phv": [
        "Arab"
    ],
    "phw": [
        "Deva"
    ],
    "pi": [
        "Deva",
        "Mymr",
        "Sinh",
        "Thai"
    ],
    "pia": [
        "Latn"
    ],
    "pib": [
        "Latn"
    ],
    "pic": [
        "Latn"
    ],
    "pid": [
        "Latn"
    ],
    "pie": [
        "Zyyy"
    ],
    "pif": [
        "Latn"
    ],
    "pig": [
        "Latn"
    ],
    "pih": [
        "Latn"
    ],
    "pii": [
        "Latn"
    ],
    "pij": [
        "Latn"
    ],
    "pil": [
        "Latn"
    ],
    "pim": [
        "Latn"
    ],
    "pin": [
        "Latn"
    ],
    "pio": [
        "Latn"
    ],
    "pip": [
        "Latn"
    ],
    "pir": [
        "Latn"
    ],
    "pis": [
        "Latn"
    ],
    "pit": [
        "Latn"
    ],
    "piu": [
        "Latn"
    ],
    "piv": [
        "Latn"
    ],
    "piw": [
        "Latn"
    ],
    "pix": [
        "Latn"
    ],
    "piy": [
        "Latn"
    ],
    "piz": [
        "Latn"
    ],
    "pjt": [
        "Latn"
    ],
    "pka": [
        "Brah"
    ],
    "pkb": [
        "Latn"
    ],
    "pkc": [
        "Zyyy"
    ],
    "pkg": [
        "Latn"
    ],
    "pkh": [
        "Deva",
        "Latn"
    ],
    "pkn": [
        "Latn"
    ],
    "pko": [
        "Latn"
    ],
    "pkp": [
        "Latn"
    ],
    "pkr": [
        "Mlym"
    ],
    "pks": [
        "Zxxx"
    ],
    "pkt": [
        "Zyyy"
    ],
    "pku": [
        "Latn"
    ],
    "pl": [
        "Latn",
        "Brai"
    ],
    "pla": [
        "Latn"
    ],
    "plb": [
        "Latn"
    ],
    "plc": [
        "Latn"
    ],
    "pld": [
        "Latn"
    ],
    "ple": [
        "Latn"
    ],
    "plg": [
        "Latn"
    ],
    "plh": [
        "Latn"
    ],
    "plj": [
        "Latn"
    ],
    "plk": [
        "Arab"
    ],
    "pll": [
        "Mymr"
    ],
    "pln": [
        "Latn"
    ],
    "plo": [
        "Latn"
    ],
    "plp": [
        "Deva"
    ],
    "plq": [
        "Zyyy"
    ],
    "plr": [
        "Latn"
    ],
    "pls": [
        "Latn"
    ],
    "plu": [
        "Latn"
    ],
    "plv": [
        "Latn"
    ],
    "plw": [
        "Latn"
    ],
    "ply": [
        "Zyyy"
    ],
    "plz": [
        "Latn"
    ],
    "pma": [
        "Latn"
    ],
    "pmb": [
        "Latn"
    ],
    "pmd": [
        "Latn"
    ],
    "pme": [
        "Latn"
    ],
    "pmf": [
        "Latn"
    ],
    "pmh": [
        "Zyyy"
    ],
    "pmi": [
        "Zyyy"
    ],
    "pmj": [
        "Zyyy"
    ],
    "pmk": [
        "Zyyy"
    ],
    "pml": [
        "Zyyy"
    ],
    "pmm": [
        "Latn"
    ],
    "pmn": [
        "Latn"
    ],
    "pmo": [
        "Latn"
    ],
    "pmq": [
        "Latn"
    ],
    "pmr": [
        "Latn"
    ],
    "pms": [
        "Latn"
    ],
    "pmt": [
        "Latn"
    ],
    "pmw": [
        "Latn"
    ],
    "pmx": [
        "Latn"
    ],
    "pmy": [
        "Latn"
    ],
    "pmz": [
        "Latn"
    ],
    "pna": [
        "Latn"
    ],
    "pnc": [
        "Latn"
    ],
    "pnd": [
        "Latn"
    ],
    "pne": [
        "Latn"
    ],
    "png": [
        "Latn"
    ],
    "pnh": [
        "Latn"
    ],
    "pni": [
        "Latn"
    ],
    "pnj": [
        "Latn"
    ],
    "pnk": [
        "Latn"
    ],
    "pnl": [
        "Latn"
    ],
    "pnm": [
        "Latn"
    ],
    "pnn": [
        "Latn"
    ],
    "pno": [
        "Latn"
    ],
    "pnp": [
        "Latn"
    ],
    "pnq": [
        "Latn"
    ],
    "pnr": [
        "Latn"
    ],
    "pns": [
        "Latn"
    ],
    "pnt": [
        "Grek",
        "Cyrl",
        "Latn"
    ],
    "pnu": [
        "Zyyy"
    ],
    "pnv": [
        "Latn"
    ],
    "pnw": [
        "Latn"
    ],
    "pnx": [
        "Zyyy"
    ],
    "pny": [
        "Latn"
    ],
    "pnz": [
        "Latn"
    ],
    "poc": [
        "Latn"
    ],
    "poe": [
        "Latn"
    ],
    "pof": [
        "Latn"
    ],
    "pog": [
        "Latn"
    ],
    "poh": [
        "Latn"
    ],
    "poi": [
        "Latn"
    ],
    "pok": [
        "Latn"
    ],
    "pom": [
        "Latn"
    ],
    "pon": [
        "Latn"
    ],
    "poo": [
        "Latn"
    ],
    "pop": [
        "Latn"
    ],
    "poq": [
        "Latn"
    ],
    "pos": [
        "Latn"
    ],
    "pot": [
        "Latn"
    ],
    "pov": [
        "Latn"
    ],
    "pow": [
        "Latn"
    ],
    "pox": [
        "Zyyy"
    ],
    "poy": [
        "Latn"
    ],
    "ppe": [
        "Latn"
    ],
    "ppi": [
        "Latn"
    ],
    "ppk": [
        "Latn"
    ],
    "ppl": [
        "Latn"
    ],
    "ppm": [
        "Latn"
    ],
    "ppn": [
        "Latn"
    ],
    "ppo": [
        "Latn"
    ],
    "ppp": [
        "Latn"
    ],
    "ppq": [
        "Latn"
    ],
    "pps": [
        "Latn"
    ],
    "ppt": [
        "Latn"
    ],
    "ppu": [
        "Zyyy"
    ],
    "pqa": [
        "Latn"
    ],
    "pqm": [
        "Latn"
    ],
    "pra": [
        "Khar"
    ],
    "prb": [
        "Zyyy"
    ],
    "prc": [
        "Arab"
    ],
    "prd": [
        "Arab"
    ],
    "pre": [
        "Latn"
    ],
    "prf": [
        "Latn"
    ],
    "prg": [
        "Latn"
    ],
    "prh": [
        "Latn"
    ],
    "pri": [
        "Latn"
    ],
    "prk": [
        "Latn"
    ],
    "prl": [
        "Zxxx"
    ],
    "prm": [
        "Latn"
    ],
    "prn": [
        "Arab"
    ],
    "pro": [
        "Latn"
    ],
    "prp": [
        "Zyyy"
    ],
    "prq": [
        "Latn"
    ],
    "prr": [
        "Latn"
    ],
    "prs": [
        "Arab"
    ],
    "prt": [
        "Thai"
    ],
    "pru": [
        "Latn"
    ],
    "prw": [
        "Latn"
    ],
    "prx": [
        "Arab",
        "Tibt"
    ],
    "prz": [
        "Zxxx"
    ],
    "ps": [
        "Arab"
    ],
    "psa": [
        "Latn"
    ],
    "psc": [
        "Zxxx"
    ],
    "psd": [
        "Zxxx"
    ],
    "pse": [
        "Latn"
    ],
    "psg": [
        "Zxxx"
    ],
    "psh": [
        "Arab"
    ],
    "psi": [
        "Arab"
    ],
    "psl": [
        "Zxxx"
    ],
    "psm": [
        "Latn"
    ],
    "psn": [
        "Latn"
    ],
    "pso": [
        "Zxxx"
    ],
    "psp": [
        "Zxxx"
    ],
    "psq": [
        "Latn"
    ],
    "psr": [
        "Zxxx"
    ],
    "pss": [
        "Latn"
    ],
    "pst": [
        "Arab"
    ],
    "psu": [
        "Brah",
        "Deva"
    ],
    "psw": [
        "Latn"
    ],
    "psy": [
        "Zyyy"
    ],
    "pt": [
        "Latn",
        "Brai"
    ],
    "pta": [
        "Latn"
    ],
    "pth": [
        "Latn"
    ],
    "pti": [
        "Latn"
    ],
    "ptn": [
        "Latn"
    ],
    "pto": [
        "Latn"
    ],
    "ptp": [
        "Latn"
    ],
    "ptq": [
        "Zyyy"
    ],
    "ptr": [
        "Latn"
    ],
    "ptt": [
        "Latn"
    ],
    "ptu": [
        "Latn"
    ],
    "ptv": [
        "Latn"
    ],
    "ptw": [
        "Zyyy"
    ],
    "pty": [
        "Zyyy"
    ],
    "pua": [
        "Latn"
    ],
    "pub": [
        "Latn"
    ],
    "puc": [
        "Latn"
    ],
    "pud": [
        "Latn"
    ],
    "pue": [
        "Latn"
    ],
    "puf": [
        "Latn"
    ],
    "pug": [
        "Latn"
    ],
    "pui": [
        "Latn"
    ],
    "puj": [
        "Latn"
    ],
    "puk": [
        "Zyyy"
    ],
    "pum": [
        "Deva"
    ],
    "puo": [
        "Latn"
    ],
    "pup": [
        "Latn"
    ],
    "puq": [
        "Latn"
    ],
    "pur": [
        "Latn"
    ],
    "put": [
        "Latn"
    ],
    "puu": [
        "Latn"
    ],
    "puw": [
        "Latn"
    ],
    "pux": [
        "Latn"
    ],
    "puy": [
        "Zyyy"
    ],
    "pwa": [
        "Latn"
    ],
    "pwb": [
        "Latn"
    ],
    "pwg": [
        "Latn"
    ],
    "pwi": [
        "Zyyy"
    ],
    "pwm": [
        "Latn"
    ],
    "pwn": [
        "Latn"
    ],
    "pwo": [
        "Mymr"
    ],
    "pwr": [
        "Deva"
    ],
    "pww": [
        "Thai"
    ],
    "pxm": [
        "Latn"
    ],
    "pye": [
        "Latn"
    ],
    "pym": [
        "Latn"
    ],
    "pyn": [
        "Latn"
    ],
    "pys": [
        "Zxxx"
    ],
    "pyu": [
        "Latn",
        "Hani"
    ],
    "pyx": [
        "Zyyy"
    ],
    "pyy": [
        "Latn"
    ],
    "pzn": [
        "Latn"
    ]
};
